/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Schedule_Frequency_MonthlyInputs */



/**
* | output |
* | --- |
* | "Every month" |
*
* @param {Agent_Schedule_Frequency_MonthlyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_schedule_frequency_monthly = /** @type {((inputs?: Agent_Schedule_Frequency_MonthlyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Schedule_Frequency_MonthlyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Monatlich")
	return /** @type {LocalizedString} */ ("Every month")
});